<template>
  <div class="day-event has-bg-white" :class="{'is-opened': isOpen, 'is-done': isAccepted}">
    <div class="columns">
      <div class="column is-narrow is-padding-right-large has-text-right is-border-right">
        <div class="columns is-height-full is-vcentered is-gapless">
          <p class="column is-self-centered has-text-centered">
            <time :datetime="date.format('DD-MMMM-YYYY')">
              <b>{{event.end_date | prettyTime}}</b>
            </time>
          </p>
          <span class="dot is-medium has-bg-success">
          </span>
        </div>
      </div>
      <div class="column is-flex" >
        <div class="is-self-centered">
          <div>
            <strong>
              <router-link :to="{name: 'LotVue', params: {id: event.lot}}">{{event.lot_ref}} </router-link>
              <span> - {{event.program_name}}</span>
            </strong>
          </div>
          <div>Déposée par :&nbsp;
            <router-link :to="{name: 'UserVue', params: {id: event.seller}}"> {{event.seller_name}}</router-link>
          </div>
          <div>Contact :&nbsp;
            <router-link :to="{name: 'ContactVue', params: {id: event.buyer}}">{{event.buyer_name}}</router-link>
          </div>
        </div>
      </div>
      <div class="column is-narrow is-self-centered actions">
        <div class="field is-grouped">
          <div class="control is-relative">
            <div class="dropdown is-hoverable is-right">
              <div class="dropdown-trigger">
                <button aria-haspopup="true" aria-controls="dropdown-menu" class="button is-white is-small is-circle">
                  <span class="icon is-small is-size-4"><i class="far fa-ellipsis-v"></i></span>
                </button>
              </div>
              <div id="dropdown-menu" role="menu" class="dropdown-menu">
                <div class="dropdown-content has-text-left">
                  <a @click="openEvent" v-if="(isAdmin || isSectorManager) && canUpgrade(event.status)" class="dropdown-item">
                    <span class="is-self-centered">Modifier échéance</span>
                  </a>
                  <a @click="acceptOption" v-if="(isAdmin || isSectorManager) && canApprove(event.status)" class="dropdown-item">
                    <span class="is-self-centered" >Accepter</span>
                  </a>
                  <a @click="refuseOption" v-if="(isAdmin || isSectorManager) && canRefuse(event.status)" class="dropdown-item">
                    <span class="is-self-centered">Refuser</span>
                  </a>
                  <a @click="deleteOption" v-if="(isAdmin || isSectorManager) && canCancel(event.status)" class="dropdown-item">
                    <span class="is-self-centered">Annuler l'option</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-border-top is-multiline is-gapless is-padding" v-if="isOpen && editOption">
      <div class="column is-3 is-2-widescreen">
        <div class="field has-addons">
          <div class="control is-expanded">
            <flat-pickr type="date" class="input is-radiusless"
              :value="dateModel"
              :config="dateConfig"
              @on-change="updateRealDate"></flat-pickr>
          </div>
        </div>
      </div>
      <div class="column is-narrow is-padding-left-small is-padding-right-small">
        <button class="button is-light" @click="closeEvent">Annuler</button>
      </div>
      <div class="column is-narrow">
        <button class="button is-primary" @click="changeOptionEndDate">Mettre à jour la date</button>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { OptionStatus, DefaultValues } from '@/mixins'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'CalendarOptionItem',
    props: {
      event: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      isOpen: {
        type: Boolean,
        default: false
      },
      selectedEvent: String
    },
    data () {
      return {
        changeOptionEndDateSelected: null,
        editOption: false,
        activeActionsMenu: false,
        dateConfig: {
          dateFormat: 'Y-d-m H:i',
          enableTime: true,
          altInput: true,
          altFormat: 'd/m/Y H:i',
          time_24hr: true,
          minDate: 'today', // this.dateModel
          minuteIncrement: 1
        }
      }
    },
    mixins: [OptionStatus, DefaultValues],
    watch: {
      isOpen (v) {
        if (!v) this.activeActionsMenu = false
      },
      selectedEvent (v) {
        if (v !== this.event.pk) this.activeActionsMenu = false
      }
    },
    computed: {
      ...mapState(['calendarEvents']),
      ...mapGetters(['isAdmin', 'isSectorManager']),
      isOption () {
        return this.type === 'OPTION'
      },
      prettyDate () {
        if (this.date) {
          return this.date.format('HH:mm')
        }
      },
      date () {
        let date = moment(this.event.end_date)

        if (date && date.isValid()) {
          return date
        } else {
          return null
        }
      },
      dateModel () {
        let res = moment()
        if (this.event) {
          res = moment(this.event.end_date).toDate()
        }
        return res
      },
      isAccepted () {
        return false // this.optionStatus[this.event.status].label === 'Acceptée'
      }
    },
    methods: {
      openEvent () {
        if (!this.editOption) {
          this.editOption = true
          this.$emit('openEvent', this.event)
        } else this.closeEvent()
      },
      closeEvent () {
        if (this.editOption) {
          this.editOption = false
          this.$emit('openEvent', null)
        } else this.openEvent()
      },
      activeMenu () {
        this.activeActionsMenu = !this.activeActionsMenu
        this.$emit('selectedEvent', this.event.pk)
      },
      deleteOption () {
        this.confirmDelete().then(r => {
          if (r.value) {
            this.$api.optionService.delete(this.event.pk).then(r => {
              this.$emit('openEvent', null)
              this.editOption = false
              this.$notify({
                type: 'is-success',
                text: 'Option acceptée'
              })
              this.currentDay = moment()
              this.$store.commit('removeCalendarEvent', {
                eventPk: this.event.pk,
                key: this.currentDay.format('DD/MM/YYYY'),
                type: 'options'
              })
            }).catch(() => {
              this.$emit('openEvent', null)
              this.editOption = false
              this.$notify({
                type: 'is-danger',
                text: 'Erreur suppression option'
              })
            })
          }
        })
      },
      confirmDelete () {
        return this.$swal({
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer cet élément ?',
          confirmButtonText: 'Supprimer'
        })
      },
      refuseOption () {
        this.$api.optionService.patch(this.event.pk, {status: 'refused'}).then(r => {
          this.editOption = false
          this.$emit('openEvent', null)
          this.$notify({
            type: 'is-success',
            text: 'Option refusée'
          })
        }).catch(() => {
          this.editOption = false
          this.$emit('openEvent', null)
          this.$notify({
            type: 'is-danger',
            text: 'Erreur modification option'
          })
        })
      },
      acceptOption () {
        this.$api.optionService.patch(this.event.pk, {status: 'approved'}).then(r => {
          this.editOption = false
          this.$emit('openEvent', null)
          this.$notify({
            type: 'is-success',
            text: 'Option acceptée'
          })
        }).catch(() => {
          this.editOption = false
          this.$emit('openEvent', null)
          this.$notify({
            type: 'is-danger',
            text: 'Erreur modification option'
          })
        })
      },
      changeOptionEndDate () {
        let hour = document.querySelector('.flatpickr-hour').value
        let minute = document.querySelector('.flatpickr-minute').value
        let newDate = moment(this.realDate).set({'hour': hour, 'minute': minute})
        this.realDate = moment(newDate).utc().format('YYYY-MM-DD H:m')
        if (moment(this.realDate).format('DDMMYYHH') === moment().utc(this.event.end_date).format('DDMMYYHH')) return
        this.editOption = false
        let data = {option: this.event, date: this.realDate}
        if (data) {
          this.$api.optionService.patch(data.option.pk, {end_date: data.date}).then(r => {
            this.editOption = false
            this.$emit('openEvent', null)
            this.loadOptions()
            this.$notify({
              type: 'is-success',
              text: 'La date de fin de l\'option a été mise à jour.'
            })
          }).catch(() => {
            this.editOption = false
            this.$emit('openEvent', null)
            this.$notify({
              type: 'is-danger',
              text: 'Impossible de mettre à jour la date de fin de l\'option.'
            })
          })
        }
      },
      updateRealDate (a) {
        if (a && a[0]) {
          const t = a[0]
          const d = new Date(t)
          const m = moment.utc(d)
          this.realDate = m.format('YYYY-MM-DD H:m')
        }
      },
      async loadOptions () {
        let params = {
          status: ['approved', 'waiting_list'],
          end_date__gte: moment(this.realDate).startOf('day').format('DD/MM/YYYY'),
          end_date__lte: moment(this.realDate).endOf('day').format('DD/MM/YYYY'),
          per_page: 100
        }
        let res = await this.$api.optionService.get(params)
        let options = res.data.items
        options.forEach(x => {
          let date = moment(x.end_date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', {event: x, key: key, type: 'options'})
        })
      }
    },
    created () {
      this.updateRealDate([this.event.end_date])
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/calendar/CalendarOptionItem.vue